<template>
  <q-popup-edit
    ref="popup"
    :value="model.value"
    content-class="r-popup-edit border-radius-sm q-pa-lg"
    :cover="false"
    @before-show="initModel"
  >
    <template #title>
      <div class="text-heading-3 text-secondary-1">{{ title }}</div>
      <CloseIcon class="close-icon" @click="hide" />
    </template>

    <template v-slot="props">
      <Grid gtc="1fr auto" gap="var(--r-space-lg)" align-items="end">
        <slot v-bind="{ ...props, loading, setLoading, model }"></slot>

        <Grid gaf="column" gap="var(--r-space-sm)" align-items="center">
          <RBtn :disable="loading" type="ghost" size="small" @click="onCancel">
            {{ cancelBtnLabel }}
          </RBtn>

          <RBtn :loading="loading" type="tertiary" size="small" @click="emitEvent(props, loading, setLoading, model)">
            {{ okBtnLabel }}
          </RBtn>
        </Grid>
      </Grid>
    </template>
  </q-popup-edit>
</template>

<script>
import CloseIcon from '@/ui/icons/CloseIcon'

export default {
  components: {
    CloseIcon
  },

  props: {
    title: {
      type: String,
      required: true
    },

    cancelBtnLabel: {
      type: String,
      default: 'cancel'
    },

    okBtnLabel: {
      type: String,
      default: 'Save'
    },

    value: null
  },

  data: () => ({
    loading: false,
    model: {
      // Object in order to make v-model work with slots
      value: null
    },
    shouldSetModel: true
  }),

  methods: {
    setLoading(state) {
      this.loading = state
    },

    onCancel() {
      this.shouldSetModel = true
      this.$refs.popup.cancel()
    },

    hide() {
      this.$refs.popup.hide()
    },

    initModel() {
      if (!this.shouldSetModel) return
      this.model.value = this.value
      this.shouldSetModel = false
    },

    emitEvent(props, loading, setLoading, model) {
      this.$emit('ok', { ...props, value: props.value, loading, setLoading, model })
    }
  }
}
</script>

<style lang="scss">
@import '~@/styles/shadows.scss';

.q-menu.r-popup-edit {
  @extend .shadow3;

  .q-dialog__title {
    margin: 0 0 var(--r-space-md);
  }

  .close-icon {
    position: absolute;
    top: var(--r-space-md);
    right: var(--r-space-md);
    height: auto;
    width: var(--r-icon-size);
  }
}
</style>
